import React, { Component } from 'react';
import Hero from "../modules/Hero/Hero";
import globals from '../globals';

class Error extends Component {

    componentDidMount() {
        // Hide the header/footer since if this page is shown we need a refresh to reset
        document.getElementById('navigation').style.display = 'none';
        document.getElementById('footer').style.display = 'none';
    }

    render() {
        const BgClass = () => {
            let random = ['internet', 'voice', 'managed-services', 'network-solutions', 'partners'];
            return 'error-bg-' + random[Math.floor(Math.random() * random.length)];
        };
        
        return (
            <Hero
                title="Whoops!"
                leadCopy={[
                    globals.getGenericErrorMsg(),
                    '<a href="/">Back to the home page<a/>.'
                ]}
                addClass={BgClass()}
            />
        );
    }

}

export default Error;


// WEBPACK FOOTER //
// ./resources/assets/js/pages/Error.js